<template>
    <div>
        <div class="block-box -left">
            <p class="mb3">辞書</p>
        </div>
        <div class="block-box -right dialect-list1">
            <label class="checkbox-inline">
                <input type="checkbox" @click="checkAllDic"  :checked="isAllCheck">
                全て
            </label>
            <label class="checkbox-inline" v-for="(item,index) in DicItems" :key="index">
                <input type="checkbox" @change="checkDic" :value="item.id" v-model="selectDic">
                {{item.name}} 
            </label>
        </div>
    </div><!-- / block -->
</template>


<script>
import {API_URL} from '@/services/config'
export default {
  name: 'SearchPage',
  props: {
    msg: String,
    test1:String,
    test2:String,
    test:String
  },
  data(){
       return {
            DicItems:[
            {id:'NKJ',name:'今帰仁'},
            {id:'SNH',name:'首里那覇'},
            {id:'AYM',name:'奄美分類'},
            {id:'SBT',name:'宮古下里'},
            {id:'SDM',name:'龍郷町瀬留'},
            {id:'YRN',name:'与論'},
            {id:'IZN',name:'伊是名'},
            {id:'IEJ',name:'伊江島'},
            {id:'IRB',name:'伊良部'},
            {id:'ISG',name:'石垣'},
            {id:'TKT',name:'竹富'},
            {id:'YNG',name:'与那国'},
            {id:'TNG',name:'種子島'},
            {id:'KGS',name:'鹿児島'}
          ],
          selectDic:[],
          isAllCheck:true
       }
  },
  mounted(){
      var self = this;

      self.$axios.get(`${API_URL}/search/getdic`)
      .then((res) => {
          self.DicItems = [];
          self.selectDic = [];
          self.DicItems = res.data.dicmst;
         // self.DicItems.map(function(value){
         //   self.selectDic.push(value.id);
         // });
          for(var item in self.DicItems){
                  self.selectDic.push(self.DicItems[item].id);
          }
          self.$emit('on-select-update', self.selectDic);
        self.isAllCheck = true;
      });

/*
      self.DicItems.map(function(value){
          self.checkDicJpWord.push(value.id);
      });
      */
      self.isCheckAllDicJpWord = true;
  //    self.checkAllDicJpWord();
  },
  methods:{
    clear(){
        this.isAllCheck = false;
        this.checkAllDic();
    },
    checkAllDic(){
          var self = this;
          self.selectDic = [];
          self.isAllCheck=!self.isAllCheck; 
          if(self.isAllCheck===true){
              for(var item in self.DicItems){
                  self.selectDic.push(self.DicItems[item].id);
              }
          }
          self.$emit('on-select-update', self.selectDic);
      },
      checkDic(){
          var self = this;
          if(self.DicItems.length !==self.selectDic.length){
              self.isAllCheck = false;
          }else{
              self.isAllCheck = true;
          }
          self.$emit('on-select-update', self.selectDic);
      },
  }

}
</script>